export const YOUTUBE = 'https://www.youtube.com/embed/';
export const VIMEO = 'https://player.vimeo.com/video/';
